import {Component, OnInit} from '@angular/core';
import {Global} from "../global";
import {Components} from "../shared/components/components";
import {TranslateService} from '@ngx-translate/core';
import {Router} from "@angular/router";
import {Funcoes} from "../funcoes";
import {LoginService} from "../login/login.service";
import {ClientesService} from "../clientes/clientes.service";
import {FichasService} from "../fichas/fichas.service";
import {FichasModel} from "../fichas/fichas.model";
import {FormBuilder, FormGroup} from "@angular/forms";
import {MercadoriasService} from "../mercadorias/mercadorias.service";
import {FaturasService} from "../faturas/faturas.service";

declare var swal, $: any;

@Component({
  selector: 'app-financeiro',
  templateUrl: './financeiro.component.html'
})
export class FinanceiroComponent extends Components implements OnInit {

  formPesquisaAvancada: FormGroup;
  filtroPesquisa = {"fStatus":"", "faturada":"", "mercadoria":"", "cliente":"", "id_fatura":"", "container":"", "data_de": "", "data_ate": "", "ordem_campo": "data_inspecao", "ordem_direcao": "d"};

  fichas: FichasModel[] = [];
  privilegioUsuario = {"editar": false, "consultar": false};

  listMercadorias = [];
  listClientes = [];
  listFaturas = [];
  listStatus = [{
    "texto": "Aguardando Revisão",
    "valor": 1
  },{
    "texto": "Online",
    "valor": 2
  }];

  listFaturada = [{
    "texto": "Sim",
    "valor": 1
  },{
    "texto": "Não",
    "valor": 0
  }];

  mascaraContainer = [/[a-zA-Z]/, /[a-zA-Z]/, /[a-zA-Z]/, /[a-zA-Z]/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/];

  constructor(
    formBuilder: FormBuilder,
    private fichasService: FichasService,
    private clientesService: ClientesService,
    private mercadoriasService: MercadoriasService,
    private faturasService: FaturasService,
    public global: Global,
    protected translate: TranslateService,
    protected router: Router,
    public func: Funcoes,
    private loginService: LoginService
  ) {
    super();

    let date = new Date().toISOString();
    this.filtroPesquisa.data_de = date.substr(0, 8)+'01';
    this.filtroPesquisa.data_ate = date.substr(0, 10);

    this.loginService.getUserInfo().subscribe(data => {
      for(let i in data.privilegios){
        if(data.privilegios[i].acao[0].url == 'financeiro'){
          this.privilegioUsuario.consultar = data.privilegios[i].consultar;
          this.privilegioUsuario.editar = data.privilegios[i].editar;
        }
      }
    });

    this.formPesquisaAvancada = formBuilder.group({
      fStatus: [],
      faturada: [],
      mercadoria: [],
      cliente: [],
      id_fatura: [],
      container: [],
      data_de: [],
      data_ate: []
    });

    // busca mercadorias
    this.mercadoriasService.get()
      .subscribe(json => {
        this.listMercadorias = json.Payload;

        if (this.global.debug == true) {
          console.log(json.Payload);
        }
      });

    // busca mercadorias
    this.clientesService.get()
      .subscribe(json => {
        this.listClientes = json.Payload;

        if (this.global.debug == true) {
          console.log(json.Payload);
        }
      });

    // busca faturas
    this.faturasService.get()
      .subscribe(json => {
        this.listFaturas = json.Payload;

        if (this.global.debug == true) {
          console.log(json.Payload);
        }
      });
  }

  ngOnInit() {
    // busca filtro salvo no localStorage
    let filtroSalvo = this.carregaFiltro();
    if (filtroSalvo) {
      this.filtroPesquisa = Object.assign(this.filtroPesquisa, filtroSalvo);
      this.formPesquisaAvancada.patchValue(filtroSalvo);
    }
    this.carregandoTabela = true;
    this.getPage(1);
  }

  setOrdem(campo: string) {
    if (this.filtroPesquisa.ordem_campo === campo) {
      this.filtroPesquisa.ordem_direcao = (this.filtroPesquisa.ordem_direcao === 'a') ? 'd' : 'a';
    } else {
      this.filtroPesquisa.ordem_campo = campo;
      this.filtroPesquisa.ordem_direcao = 'a';
    }
    this.salvaFiltro(this.filtroPesquisa);
    this.getPage(1);
  }

  getPage(pagina){
    this.paginaAtual = pagina;
    this.carregandoTabela = true;

    let filtros = {};

    if (this.filtroPesquisa.data_de && this.filtroPesquisa.data_ate) {
      filtros['data_inspecao'] = 'bt:' + this.filtroPesquisa.data_de + '|' + this.filtroPesquisa.data_ate;
    } else {
      if (this.filtroPesquisa.data_de) {
        filtros['data_inspecao'] = 'ge:' + this.filtroPesquisa.data_de;
      }

      if (this.filtroPesquisa.data_ate) {
        filtros['data_inspecao'] = 'le:' + this.filtroPesquisa.data_ate;
      }
    }

    if(this.filtroPesquisa.fStatus != ''){
      filtros['id_status'] = "**:"+this.filtroPesquisa.fStatus;
    }else{
      filtros['id_status'] = '2';
    }

    if(this.filtroPesquisa.faturada != ''){
      filtros['faturada'] = "**:"+this.filtroPesquisa.faturada;
    }

    if(this.filtroPesquisa.mercadoria != ''){
      filtros['id_mercadoria'] = "**:"+this.filtroPesquisa.mercadoria;
    }

    if(this.filtroPesquisa.cliente != ''){
      filtros['id_cliente'] = "**:"+this.filtroPesquisa.cliente;
    }

    if(this.filtroPesquisa.id_fatura != ''){
      filtros['id_fatura'] = "**:"+this.filtroPesquisa.id_fatura;
    }

    if(this.filtroPesquisa.container != ''){
      filtros['container'] = "**:"+this.filtroPesquisa.container;
    }

    let sort = {};
    let campoSort = this.filtroPesquisa.ordem_campo || 'data_inspecao';
    let direcaoSort = this.filtroPesquisa.ordem_direcao || 'd';
    sort[campoSort] = direcaoSort;

    this.fichasService.getPaginacao(pagina,this.itensPorPagina, ['mercadoria', 'cliente', 'status', 'fatura_gerada'], filtros, null, sort)
      .subscribe(data => {
          this.fichas = data['Payload']['data'];
          this.totalItens = data['Payload']['total'];
          this.carregandoTabela = false;

          if (this.global.debug) {
            console.log(this.fichas);
          }
        },
        error => {
          this.func.showErro(error.json());
          this.carregandoTabela = false;
        });
  }

  faturarContainer(container){

    let fichasService = this.fichasService;

    let self = this;

    swal({
        title: this.func.traduzir('front.voceTemCerteza'),
        text: this.func.traduzir('front.desejaFaturarContainer')+container,
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: 'btn-danger',
        confirmButtonText: this.func.traduzir('front.confirmar'),
        cancelButtonText: this.func.traduzir('front.cancelar'),
        closeOnConfirm: true,
      },
      function(){

        fichasService.faturarContainer(container)
          .subscribe(res => {
              //swal(self.func.traduzir('front.sucesso'), self.func.traduzir('front.statusAlterado'), "success");
              self.getPage(self.paginaAtual);
            },
            error => {
              //swal(self.func.traduzir('front.erro'), self.func.traduzir('front.statusNaoAlterado'), "error");

              self.func.showErro(error.json());
            });

      });
  }

  modalPesquisaAvancada(){
    $('#modalPesquisaAvancada').modal('show');
  }

  pesquisaAvancada(){
    if (this.filtroPesquisa.data_de && !this.filtroPesquisa.data_ate) {
      this.filtroPesquisa.data_ate = new Date().toISOString().split('T')[0];
      this.formPesquisaAvancada.patchValue(this.filtroPesquisa);
    }
    this.salvaFiltro(this.filtroPesquisa);
    this.getPage(1);
    $('#modalPesquisaAvancada').modal('hide');
  }

  limpaPesquisaAvancada(){
    this.filtroPesquisa = {"fStatus":"", "faturada":"", "mercadoria":"", "cliente":"", "id_fatura":"", "container":"", "data_de": "", "data_ate": "", "ordem_campo": "data_inspecao", "ordem_direcao": "d"};
    this.limpaFiltroSalvo();
    this.formPesquisaAvancada.patchValue(this.filtroPesquisa);
    this.getPage(1);
  }

  // evento quando o container é alterado
  changeContainer(e){
    this.filtroPesquisa.container = e.toUpperCase().replace(/_/g, '');
  }

}



// WEBPACK FOOTER //
// ./src/app/financeiro/financeiro.component.ts